import React from 'react';
import { IInvoice } from '../interface/IInvoice';
import { Button, DialogTitle, FormControl, FormLabel, Input, Modal, ModalDialog, Stack } from '@mui/joy';

type Props = {
  open: boolean;
  submitting: boolean;
  onClose: () => void;
  onSubmit: (invoiceId: string, paymentDate: string) => void;
  invoice: IInvoice | null;
};
const InvoicePaymentModal = ({ open, submitting, onClose, onSubmit, invoice }: Props) => {
  return (
    <Modal
      aria-labelledby='modal-title'
      aria-describedby='modal-desc'
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <ModalDialog>
        <DialogTitle>Payment: {invoice?.invoiceId ?? ''}</DialogTitle>
        <form
          onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            try {
              const formData = new FormData(event.currentTarget);
              const formJson: any = Object.fromEntries((formData as any).entries());
              if (invoice && invoice.invoiceId) onSubmit(invoice?.invoiceId, formJson.dateOfPayment);
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <Stack>
            {invoice && (
              <FormControl required>
                <FormLabel>Date of Payment</FormLabel>
                <Input name='dateOfPayment' type='date' />
              </FormControl>
            )}
          </Stack>

          <Button type='submit' style={{ marginTop: 15 }} loading={submitting}>
            Submit
          </Button>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default InvoicePaymentModal;
